import axiosInstance from "./mainApi";
import store from "../store/store";
import {
  addScriptSave,
  addMoreScriptSaves,
  updateScriptSave,
  deleteScriptSave
} from "../store/actions/scriptSaveStoreFunctions";

const sortScriptSaves = (arr = []) =>
  [...arr].sort((a, b) => (a.saveId ?? 0) - (b.saveId ?? 0));

const getAllScriptSavesApi = async () => {
  try {
    const response = await axiosInstance.get("/script-saves");

    if (response.status === 200) {
      const data = Array.isArray(response.data) ? response.data : [];
      const sorted = sortScriptSaves(data);

      store.dispatch(addMoreScriptSaves(sorted));

      return sorted;
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching script saves:", error);
    throw error;
  }
};

const getScriptSavesForScriptApi = async (scriptId) => {
  try {
    const response = await axiosInstance.get(
      `/script-saves?scriptId=${scriptId}`
    );

    if (response.status === 200) {
      const data = Array.isArray(response.data) ? response.data : [];
      const sorted = sortScriptSaves(data);

      store.dispatch(addMoreScriptSaves(sorted));

      return sorted;
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching script saves:", error);
    throw error;
  }
};

const createScriptSaveApi = (data) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post("/script-saves", data);

      dispatch(addScriptSave(response.data));

      return response.data;
    } catch (error) {
      console.error("Error creating script save:", error);
      throw error;
    }
  };
};

const updateScriptSaveApi = (saveId, data) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.put(`/script-saves/${saveId}`, data);

      dispatch(updateScriptSave(response.data));

      return response.data;
    } catch (error) {
      console.error("Error updating script save:", error);
      throw error;
    }
  };
};

const deleteScriptSaveApi = (saveId) => {
  return async (dispatch) => {
    try {
      await axiosInstance.delete(`/script-saves/${saveId}`);

      dispatch(deleteScriptSave(saveId));
    } catch (error) {
      console.error("Error deleting script save:", error);
      throw error;
    }
  };
};

export default {
  getAllScriptSavesApi,
  getScriptSavesForScriptApi,
  createScriptSaveApi,
  updateScriptSaveApi,
  deleteScriptSaveApi
};
